import { Box, CircularProgress, Grid } from '@mui/material';

import { FBoxContainer } from '../../../../../../../components/baseV2';
import { QuestionnaireSectionLabel } from '../../../../../common';
import { LOADING_OVERLAY_SX } from '../styles';
import InsuranceCoverageFields from './InsuranceCoverageFields';
import InsuranceMemberFields from './InsuranceMemberFields';

import type { InsuranceInformationFieldsProps } from './types';

export default function InsuranceInformationFields({
  isExtracting,
  formik,
  disabled,
  saveFieldOnBlur,
  insuranceStartDisabledDate,
  insuranceEndDisabledDate,
  handleAddressFieldChange,
  saveAddressFieldOnChange,
}: InsuranceInformationFieldsProps) {
  return (
    <Box sx={{ position: 'relative' }}>
      {isExtracting ? (
        <Box sx={LOADING_OVERLAY_SX}>
          <CircularProgress size={32} />
        </Box>
      ) : null}
      <FBoxContainer>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <QuestionnaireSectionLabel variant="h6">
              Insurance Information
            </QuestionnaireSectionLabel>
          </Grid>
          <InsuranceCoverageFields
            disabled={disabled}
            formik={formik}
            insuranceEndDisabledDate={insuranceEndDisabledDate}
            insuranceStartDisabledDate={insuranceStartDisabledDate}
            saveFieldOnBlur={saveFieldOnBlur}
          />
          <InsuranceMemberFields
            disabled={disabled}
            formik={formik}
            handleAddressFieldChange={handleAddressFieldChange}
            saveAddressFieldOnChange={saveAddressFieldOnChange}
            saveFieldOnBlur={saveFieldOnBlur}
          />
        </Grid>
      </FBoxContainer>
    </Box>
  );
}
